import axios from "axios";
import { cnpjCanonical } from "./cnpjService";

const { REACT_APP_API } = process.env;

export const verificarBloqueioCnpj = async (cnpj) => {
  const cnpjSemFormatacao = cnpjCanonical(cnpj);

  const response = await axios.get(
    `${REACT_APP_API}bloqueiocnpj/verificar?cnpj=${cnpjSemFormatacao}`
  );

  return response.data;
};
